export var AuthActionType;
(function (AuthActionType) {
    AuthActionType["CLEAR_TOKENS"] = "AUTH/CLEAR_TOKENS";
    AuthActionType["LOGIN"] = "AUTH/LOGIN";
    AuthActionType["LOGOUT"] = "AUTH/LOGOUT";
    AuthActionType["SET_TOKENS"] = "AUTH/SET_TOKENS";
})(AuthActionType || (AuthActionType = {}));
export var clearTokens = function () { return ({ type: AuthActionType.CLEAR_TOKENS }); };
export var login = function (payload) { return ({ type: AuthActionType.LOGIN, payload: payload }); };
export var logout = function () { return ({ type: AuthActionType.LOGOUT }); };
export var setTokens = function () { return ({ type: AuthActionType.SET_TOKENS }); };
//# sourceMappingURL=actions.js.map